import React, { useState, useEffect, useCallback } from "react";
import { Auth } from "aws-amplify";
import { jwtDecode } from "jwt-decode";
import config from "../../aws-exports";
import {
  FormControl,
  Select,
  MenuItem,
  TextField,
  Typography,
  FormHelperText,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Switch,
  IconButton,
  Box,
  Tooltip,
  Autocomplete,
  Modal,
  Paper,
  Button,
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchFilter from "../Requirement/components/common/SearchFilter";
import { useLoading } from "../../context/LoadingContext";
import {
  fetchData,
  postQuery,
  uploadVideoToS3,
  searchfetchQueries,
} from "../Requirement/services/RequirementServices";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import AlertModal from "../Requirement/components/common/AlerModel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RemoveIcon from "@mui/icons-material/Remove";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

// RFQ Overview Tab Component
const RFQOverview = ({
  countrymaster,
  incotermsMaster,
  paymentTermMaster,
  formData,
  errors,
  handleChange,
  formMode,
  currentDate,
  loadFormPorts,
}) => {
  const handleOriginChange = useCallback(
    (e) => {
      const country = e.target.value;
      handleChange(e);
      if (country && formMode !== "view") {
        loadFormPorts(country, "origin");
      }
    },
    [handleChange, loadFormPorts, formMode]
  );

  const handleDeliveryChange = useCallback(
    (e) => {
      const country = e.target.value;
      handleChange(e);
      if (country && formMode !== "view") {
        loadFormPorts(country, "delivery");
      }
    },
    [handleChange, loadFormPorts, formMode]
  );

  return (
    <div className="tab-pane active">
      <div className="row g-3">
        <div className="col-md-4">
          <FormControl
            fullWidth
            error={!!errors.applicantName}
            disabled={formMode === "view"}
          >
            <Typography variant="body2">Applicant Name (Buyer) *</Typography>
            <TextField
              name="applicantName"
              value={formData.applicantName || ""}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              inputProps={{ readOnly: formMode === "view" }}
              aria-label="Applicant Name"
            />
            {errors.applicantName && (
              <FormHelperText>{errors.applicantName}</FormHelperText>
            )}
          </FormControl>
        </div>
        <div className="col-md-4">
          <FormControl
            fullWidth
            error={!!errors.beneficiaryName}
            disabled={formMode === "view"}
          >
            <Typography variant="body2">Beneficiary Name (Seller) *</Typography>
            <TextField
              name="beneficiaryName"
              value={formData.beneficiaryName || ""}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              inputProps={{ readOnly: formMode === "view" }}
              aria-label="Beneficiary Name"
            />
            {errors.beneficiaryName && (
              <FormHelperText>{errors.beneficiaryName}</FormHelperText>
            )}
          </FormControl>
        </div>
        <div className="col-md-4">
          <FormControl
            fullWidth
            error={!!errors.lcAmount}
            disabled={formMode === "view"}
          >
            <Typography variant="body2">LC Amount *</Typography>
            <TextField
              name="lcAmount"
              type="number"
              value={formData.lcAmount || ""}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              inputProps={{ readOnly: formMode === "view", step: "any" }}
              aria-label="LC Amount"
            />
            {errors.lcAmount && (
              <FormHelperText>{errors.lcAmount}</FormHelperText>
            )}
          </FormControl>
        </div>
        <div className="col-md-4">
          <FormControl
            fullWidth
            error={!!errors.lcCurrency}
            disabled={formMode === "view"}
          >
            <Typography variant="body2">LC Currency *</Typography>
            <TextField
              name="lcCurrency"
              value={formData.lcCurrency || ""}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              inputProps={{ readOnly: formMode === "view" }}
              aria-label="LC Currency"
            />
            {errors.lcCurrency && (
              <FormHelperText>{errors.lcCurrency}</FormHelperText>
            )}
          </FormControl>
        </div>
        <div className="col-md-4">
          <FormControl
            fullWidth
            error={!!errors.lcType}
            disabled={formMode === "view"}
          >
            <Typography variant="body2">Type of LC *</Typography>
            <TextField
              name="lcType"
              value={formData.lcType || ""}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              inputProps={{ readOnly: formMode === "view" }}
              aria-label="Type of LC"
            />
            {errors.lcType && <FormHelperText>{errors.lcType}</FormHelperText>}
          </FormControl>
        </div>
        {formData.lcType === "Usance" && (
          <div className="col-md-4">
            <FormControl fullWidth disabled={formMode === "view"}>
              <Typography variant="body2">
                LC Tenor / Maturity Period
              </Typography>
              <TextField
                name="lcTenor"
                value={formData.lcTenor || ""}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                inputProps={{ readOnly: formMode === "view" }}
                aria-label="LC Tenor"
              />
            </FormControl>
          </div>
        )}
        <div className="col-md-4">
          <FormControl
            fullWidth
            error={!!errors.incoterm}
            disabled={formMode === "view"}
          >
            <Typography variant="body2">Incoterm *</Typography>
            <Select
              name="incoterm"
              value={formData.incoterm || ""}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              inputProps={{ readOnly: formMode === "view" }}
              aria-label="Incoterm"
            >
              <MenuItem value="">
                <em>Select Incoterm</em>
              </MenuItem>
              {incotermsMaster.map((incoterm) => (
                <MenuItem key={incoterm.Value} value={incoterm.Value}>
                  {incoterm.Value}
                </MenuItem>
              ))}
            </Select>
            {errors.incoterm && (
              <FormHelperText>{errors.incoterm}</FormHelperText>
            )}
          </FormControl>
        </div>
        <div className="col-md-4">
          <FormControl
            fullWidth
            error={!!errors.countryOrigin}
            disabled={formMode === "view"}
          >
            <Typography variant="body2">Country of Origin *</Typography>
            <Select
              name="countryOrigin"
              value={formData.countryOrigin || ""}
              onChange={handleOriginChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              inputProps={{ readOnly: formMode === "view" }}
              aria-label="Country of Origin"
            >
              <MenuItem value="">
                <em>Select Country</em>
              </MenuItem>
              {countrymaster.map((country) => (
                <MenuItem key={country.Value} value={country.Value}>
                  {country.Value}
                </MenuItem>
              ))}
            </Select>
            {errors.countryOrigin && (
              <FormHelperText>{errors.countryOrigin}</FormHelperText>
            )}
          </FormControl>
        </div>
        <div className="col-md-4">
          <FormControl
            fullWidth
            error={!!errors.countryDestination}
            disabled={formMode === "view"}
          >
            <Typography variant="body2">Country of Destination *</Typography>
            <Select
              name="countryDestination"
              value={formData.countryDestination || ""}
              onChange={handleDeliveryChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              inputProps={{ readOnly: formMode === "view" }}
              aria-label="Country of Destination"
            >
              <MenuItem value="">
                <em>Select Country</em>
              </MenuItem>
              {countrymaster.map((country) => (
                <MenuItem key={country.Value} value={country.Value}>
                  {country.Value}
                </MenuItem>
              ))}
            </Select>
            {errors.countryDestination && (
              <FormHelperText>{errors.countryDestination}</FormHelperText>
            )}
          </FormControl>
        </div>
        <div className="col-md-4">
          <FormControl
            fullWidth
            error={!!errors.goodsDescription}
            disabled={formMode === "view"}
          >
            <Typography variant="body2">Goods Description *</Typography>
            <TextField
              name="goodsDescription"
              value={formData.goodsDescription || ""}
              onChange={handleChange}
              multiline
              rows={3}
              size="small"
              sx={{ backgroundColor: "white" }}
              inputProps={{ readOnly: formMode === "view" }}
              aria-label="Goods Description"
            />
            {errors.goodsDescription && (
              <FormHelperText>{errors.goodsDescription}</FormHelperText>
            )}
          </FormControl>
        </div>
        <div className="col-md-12">
          <FormControl fullWidth disabled={formMode === "view"}>
            <Typography variant="body2">Required Documents *</Typography>
            <div className="d-flex flex-wrap gap-3">
              {[
                { label: "Commercial Invoice", name: "commercialInvoice" },
                { label: "Bill of Lading (BL)", name: "billOfLading" },
                {
                  label: "Certificate of Analysis (COA)",
                  name: "certificateOfAnalysis",
                },
                { label: "Packing List", name: "packingList" },
                { label: "Certificate of Origin", name: "certificateOfOrigin" },
                { label: "Insurance Policy", name: "insurancePolicy" },
                {
                  label: "Inspection Certificate",
                  name: "inspectionCertificate",
                },
              ].map((doc) => (
                <FormControlLabel
                  key={doc.name}
                  control={
                    <Checkbox
                      name={doc.name}
                      checked={formData.requiredDocuments?.[doc.name] || false}
                      onChange={handleChange}
                      disabled={formMode === "view"}
                      size="small"
                      sx={{
                        color: "#de6b14",
                        "&.Mui-checked": {
                          color: "#de6b14",
                        },
                      }}
                    />
                  }
                  label={doc.label}
                />
              ))}
            </div>
          </FormControl>
        </div>
        <div className="col-md-4">
          <FormControl fullWidth disabled={formMode === "view"}>
            <Typography variant="body2">
              Advising / Confirming Bank (optional)
            </Typography>
            <TextField
              name="advisingConfirmingBank"
              value={formData.advisingConfirmingBank || ""}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              inputProps={{ readOnly: formMode === "view" }}
              aria-label="Advising / Confirming Bank"
            />
          </FormControl>
        </div>
        <div className="col-md-4">
          <FormControl
            fullWidth
            error={!!errors.lcOpeningBankDetails}
            disabled={formMode === "view"}
          >
            <Typography variant="body2">LC Opening Bank Details *</Typography>
            <TextField
              name="lcOpeningBankDetails"
              value={formData.lcOpeningBankDetails || ""}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              inputProps={{ readOnly: formMode === "view" }}
              aria-label="LC Opening Bank Details"
            />
            {errors.lcOpeningBankDetails && (
              <FormHelperText>{errors.lcOpeningBankDetails}</FormHelperText>
            )}
          </FormControl>
        </div>
        <div className="col-md-4">
          <FormControl
            fullWidth
            error={!!errors.expiryDate}
            disabled={formMode === "view"}
          >
            <Typography variant="body2">Expiry Date *</Typography>
            <TextField
              name="expiryDate"
              type="date"
              value={formData.expiryDate || currentDate}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              inputProps={{ readOnly: formMode === "view" }}
              aria-label="Expiry Date"
            />
            {errors.expiryDate && (
              <FormHelperText>{errors.expiryDate}</FormHelperText>
            )}
          </FormControl>
        </div>
        <div className="col-md-4">
          <FormControl
            fullWidth
            error={!!errors.expiryPlace}
            disabled={formMode === "view"}
          >
            <Typography variant="body2">Expiry Place *</Typography>
            <TextField
              name="expiryPlace"
              value={formData.expiryPlace || ""}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              inputProps={{ readOnly: formMode === "view" }}
              aria-label="Expiry Place"
            />
            {errors.expiryPlace && (
              <FormHelperText>{errors.expiryPlace}</FormHelperText>
            )}
          </FormControl>
        </div>
        <div className="col-md-4">
          <FormControl
            fullWidth
            error={!!errors.paymentTerms}
            disabled={formMode === "view"}
          >
            <Typography variant="body2">Payment Terms *</Typography>
            <Select
              name="paymentTerms"
              value={formData.paymentTerms || ""}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              inputProps={{ readOnly: formMode === "view" }}
              aria-label="Payment Terms"
            >
              <MenuItem value="">
                <em>Select Payment Terms</em>
              </MenuItem>
              {paymentTermMaster.map((term) => (
                <MenuItem key={term.Value} value={term.Value}>
                  {term.Value}
                </MenuItem>
              ))}
            </Select>
            {errors.paymentTerms && (
              <FormHelperText>{errors.paymentTerms}</FormHelperText>
            )}
          </FormControl>
        </div>
      </div>
    </div>
  );
};

// Trade & Transaction Details Tab Component
const TradeTransactionDetails = ({
  formData,
  errors,
  handleChange,
  formMode,
  currentDate,
  formOriginPortList,
  formDeliveryPortList,
  incotermsMaster,
}) => (
  <div className="tab-pane">
    <div className="row g-3">
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Trade Type</Typography>
          <Select
            name="tradeType"
            value={formData.tradeType || ""}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view" }}
            aria-label="Trade Type"
          >
            <MenuItem value="">
              <em>Select Trade Type</em>
            </MenuItem>
            {["Import", "Export", "Domestic"].map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Commodity Description</Typography>
          <TextField
            name="commodityDescription"
            value={formData.commodityDescription}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            placeholder="e.g., Soybeans, Crude Oil, Textiles"
            inputProps={{ "aria-label": "Commodity Description" }}
            disabled={formMode === "view"}
          />
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">HS Code (Optional)</Typography>
          <TextField
            name="hsCode"
            value={formData.hsCode || ""}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view" }}
            aria-label="HS Code"
          />
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Buyer Name & Country</Typography>
          <TextField
            name="buyerNameCountry"
            value={formData.buyerNameCountry || ""}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view" }}
            aria-label="Buyer Name & Country"
          />
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Seller Name & Country</Typography>
          <TextField
            name="sellerNameCountry"
            value={formData.sellerNameCountry || ""}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view" }}
            aria-label="Seller Name & Country"
          />
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl
          fullWidth
          disabled={formMode === "view" || !formData.countryOrigin}
        >
          <Typography variant="body2">Port of Loading</Typography>
          <Select
            name="portLoading"
            value={formData.portLoading || ""}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view" }}
            aria-label="Port of Loading"
          >
            <MenuItem value="">
              {formData.countryOrigin ? "Select Port" : "Select Country First"}
            </MenuItem>
            {formOriginPortList.map((port, index) => (
              <MenuItem key={index} value={port.Value}>
                {port.Value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl
          fullWidth
          disabled={formMode === "view" || !formData.countryDestination}
        >
          <Typography variant="body2">Port of Discharge</Typography>
          <Select
            name="portDischarge"
            value={formData.portDischarge || ""}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view" }}
            aria-label="Port of Discharge"
          >
            <MenuItem value="">
              {formData.countryDestination
                ? "Select Port"
                : "Select Country First"}
            </MenuItem>
            {formDeliveryPortList.map((port, index) => (
              <MenuItem key={index} value={port.Value}>
                {port.Value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Trade Incoterms</Typography>
          <Select
            name="tradeIncoterms"
            value={formData.tradeIncoterms || ""}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view" }}
            aria-label="Trade Incoterms"
          >
            <MenuItem value="">
              <em>Select Incoterm</em>
            </MenuItem>
            {incotermsMaster.map((incoterm) => (
              <MenuItem key={incoterm.Value} value={incoterm.Value}>
                {incoterm.Value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Shipment Date (Estimated)</Typography>
          <TextField
            name="shipmentDate"
            type="date"
            value={formData.shipmentDate || currentDate}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view" }}
            aria-label="Shipment Date"
          />
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Trade Value (Invoice Amount)</Typography>
          <TextField
            name="tradeValue"
            type="number"
            value={formData.tradeValue || ""}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view", step: "any" }}
            aria-label="Trade Value"
          />
        </FormControl>
      </div>
    </div>
  </div>
);

// Instrument Terms Tab Component
const InstrumentTerms = ({ formData, errors, handleChange, formMode }) => (
  <div className="tab-pane">
    <div className="row g-3">
      <div className="col-md-3">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">
            Advising / Confirming Bank Required?
          </Typography>
          <FormControlLabel
            control={
              <Switch
                name="advisingConfirmingBankRequired"
                checked={formData.advisingConfirmingBankRequired || false}
                onChange={handleChange}
                disabled={formMode === "view"}
                size="small"
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#de6b14",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#de6b14",
                  },
                }}
              />
            }
            label={formData.advisingConfirmingBankRequired ? "Yes" : "No"}
          />
        </FormControl>
      </div>
      <div className="col-md-3">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Confirmation Required?</Typography>
          <FormControlLabel
            control={
              <Switch
                name="confirmationRequired"
                checked={formData.confirmationRequired || false}
                onChange={handleChange}
                disabled={formMode === "view"}
                size="small"
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#de6b14",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#de6b14",
                  },
                }}
              />
            }
            label={formData.confirmationRequired ? "Yes" : "No"}
          />
        </FormControl>
      </div>
      <div className="col-md-3">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Partial Shipment Allowed?</Typography>
          <FormControlLabel
            control={
              <Switch
                name="partialShipmentAllowed"
                checked={formData.partialShipmentAllowed || false}
                onChange={handleChange}
                disabled={formMode === "view"}
                size="small"
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#de6b14",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#de6b14",
                  },
                }}
              />
            }
            label={formData.partialShipmentAllowed ? "Yes" : "No"}
          />
        </FormControl>
      </div>
      <div className="col-md-3">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Transshipment Allowed?</Typography>
          <FormControlLabel
            control={
              <Switch
                name="transshipmentAllowed"
                checked={formData.transshipmentAllowed || false}
                onChange={handleChange}
                disabled={formMode === "view"}
                size="small"
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#de6b14",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#de6b14",
                  },
                }}
              />
            }
            label={formData.transshipmentAllowed ? "Yes" : "No"}
          />
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Revolving Terms</Typography>
          <TextField
            name="instrumentTerms"
            value={formData.instrumentTerms}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            placeholder="Leave blank for open bidding"
            inputProps={{ "aria-label": "Instrument Terms" }}
            disabled={formMode === "view"}
          />
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Confirmation Charges</Typography>
          <TextField
            name="confirmationCharges"
            type="number"
            value={formData.confirmationCharges || ""}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view", step: "0.01" }}
            aria-label="Confirmation Charges"
          />
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Issuance Charges</Typography>
          <TextField
            name="issuanceCharges"
            type="number"
            value={formData.issuanceCharges || ""}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view", step: "0.01" }}
            aria-label="Issuance Charges"
          />
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Interest Rate Margin (%)</Typography>
          <TextField
            name="interestRateMargin"
            type="number"
            value={formData.interestRateMargin || ""}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view", step: "0.01" }}
            aria-label="Interest Rate Margin"
          />
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Tenor Offered (Days/Months)</Typography>
          <TextField
            name="tenorOffered"
            value={formData.tenorOffered || ""}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view" }}
            aria-label="Tenor Offered"
          />
        </FormControl>
      </div>
    </div>
  </div>
);

// Document Requirements Tab Component
const DocumentRequirements = ({ formData, errors, handleChange, formMode }) => (
  <div className="tab-pane">
    <div className="row g-3">
      <div className="col-md-12">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Documents Required</Typography>
          <div className="d-flex flex-wrap gap-3">
            {[
              { label: "Commercial Invoice", name: "commercialInvoice" },
              { label: "Bill of Lading", name: "billOfLading" },
              { label: "Packing List", name: "packingList" },
              { label: "Certificate of Origin", name: "certificateOfOrigin" },
              { label: "Insurance Policy", name: "insurancePolicy" },
              {
                label: "Inspection Certificate",
                name: "inspectionCertificate",
              },
            ].map((doc) => (
              <FormControlLabel
                key={doc.name}
                control={
                  <Checkbox
                    name={doc.name}
                    checked={formData.requiredDocuments?.[doc.name] || false}
                    onChange={handleChange}
                    disabled={formMode === "view"}
                    size="small"
                    sx={{
                      color: "#de6b14",
                      "&.Mui-checked": {
                        color: "#de6b14",
                      },
                    }}
                  />
                }
                label={doc.label}
              />
            ))}
          </div>
        </FormControl>
      </div>
      <div className="col-md-12">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Additional Documents</Typography>
          <TextField
            name="additionalDocuments"
            value={formData.additionalDocuments || ""}
            onChange={handleChange}
            multiline
            rows={3}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view" }}
            aria-label="Additional Documents"
          />
        </FormControl>
      </div>
      <div className="col-md-12">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">
            Special Conditions / Clauses (Optional)
          </Typography>
          <TextField
            name="specialConditions"
            value={formData.specialConditions || ""}
            onChange={handleChange}
            multiline
            rows={3}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view" }}
            aria-label="Special Conditions"
          />
        </FormControl>
      </div>
    </div>
  </div>
);

// Attachments Tab Component
const Attachments = ({
  formData,
  formMode,
  fileUrl,
  handleOpenProformaModal,
  handleOpenTradeModal,
  handleOpenKycModal,
}) => (
  <div className="tab-pane">
    <div className="row g-3">
      {/* Proforma Invoice / Contract */}
      <div className="col-md-4">
        <Typography variant="body2">Proforma Invoice / Contract</Typography>
        <Box
          sx={{
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "8px",
            minHeight: "120px",
            backgroundColor: "white",
          }}
        >
          {formData.proformaInvoiceFile ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "4px 8px",
                marginBottom: "4px",
                backgroundColor: "#f5f5f5",
                borderRadius: "4px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <PictureAsPdfIcon sx={{ marginRight: 1, color: "#d32f2f" }} />
                <Typography variant="body2">
                  <a
                    href={fileUrl + formData.proformaInvoiceFile.filePath}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {formData.proformaInvoiceFile.name}
                  </a>
                </Typography>
              </Box>
              {formMode !== "view" && (
                <IconButton
                  size="small"
                  onClick={() => {}}
                  sx={{ color: "#d32f2f", width: "auto" }}
                >
                  <RemoveIcon />
                </IconButton>
              )}
            </Box>
          ) : (
            <Typography variant="body2" color="textSecondary">
              No proforma invoice file uploaded
            </Typography>
          )}
          {formMode !== "view" && (
            <Button
              startIcon={<UploadFileIcon />}
              onClick={handleOpenProformaModal}
              sx={{ marginTop: 1, backgroundColor: "#ff9800", color: "#fff" }}
              variant="contained"
            >
              Upload Proforma Invoice
            </Button>
          )}
        </Box>
      </div>
      {/* Supporting Trade Docs */}
      <div className="col-md-4">
        <Typography variant="body2">
          Supporting Trade Docs (PO, BL, KYB, etc.)
        </Typography>
        <Box
          sx={{
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "8px",
            minHeight: "120px",
            backgroundColor: "white",
          }}
        >
          {formData.tradeDocsFile ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "4px 8px",
                marginBottom: "4px",
                backgroundColor: "#f5f5f5",
                borderRadius: "4px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <PictureAsPdfIcon sx={{ marginRight: 1, color: "#d32f2f" }} />
                <Typography variant="body2">
                  <a
                    href={fileUrl + formData.tradeDocsFile.filePath}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {formData.tradeDocsFile.name}
                  </a>
                </Typography>
              </Box>
              {formMode !== "view" && (
                <IconButton
                  size="small"
                  onClick={() => {}}
                  sx={{ color: "#d32f2f", width: "auto" }}
                >
                  <RemoveIcon />
                </IconButton>
              )}
            </Box>
          ) : (
            <Typography variant="body2" color="textSecondary">
              No trade documents uploaded
            </Typography>
          )}
          {formMode !== "view" && (
            <Button
              startIcon={<UploadFileIcon />}
              onClick={handleOpenTradeModal}
              sx={{ marginTop: 1, backgroundColor: "#ff9800", color: "#fff" }}
              variant="contained"
            >
              Upload Trade Documents
            </Button>
          )}
        </Box>
      </div>
      {/* Company Profile / KYC Docs */}
      <div className="col-md-4">
        <Typography variant="body2">
          Company Profile / KYC Docs (Optional)
        </Typography>
        <Box
          sx={{
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "8px",
            minHeight: "120px",
            backgroundColor: "white",
          }}
        >
          {formData.kycDocsFile ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "4px 8px",
                marginBottom: "4px",
                backgroundColor: "#f5f5f5",
                borderRadius: "4px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <PictureAsPdfIcon sx={{ marginRight: 1, color: "#d32f2f" }} />
                <Typography variant="body2">
                  <a
                    href={fileUrl + formData.kycDocsFile.filePath}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {formData.kycDocsFile.name}
                  </a>
                </Typography>
              </Box>
              {formMode !== "view" && (
                <IconButton
                  size="small"
                  onClick={() => {}}
                  sx={{ color: "#d32f2f", width: "auto" }}
                >
                  <RemoveIcon />
                </IconButton>
              )}
            </Box>
          ) : (
            <Typography variant="body2" color="textSecondary">
              No KYC documents uploaded
            </Typography>
          )}
          {formMode !== "view" && (
            <Button
              startIcon={<UploadFileIcon />}
              onClick={handleOpenKycModal}
              sx={{ marginTop: 1, backgroundColor: "#ff9800", color: "#fff" }}
              variant="contained"
            >
              Upload KYC Documents
            </Button>
          )}
        </Box>
      </div>
    </div>
  </div>
);

// Terms & Timing Tab Component
const TermsTiming = ({
  formData,
  errors,
  handleChange,
  formMode,
  currentDate,
}) => (
  <div className="tab-pane">
    <div className="row g-3">
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Response Deadline for banks</Typography>
          <TextField
            name="responseDeadline"
            type="date"
            value={formData.responseDeadline || currentDate}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view" }}
            aria-label="Response Deadline"
          />
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">Preferred Financing Rate Type</Typography>
          <TextField
            name="preferredFinancingRateType"
            value={formData.preferredFinancingRateType || ""}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view" }}
            aria-label="Preferred Financing Rate Type"
          />
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">
            Maximum Acceptable Charges (% or absolute)
          </Typography>
          <TextField
            name="maximumAcceptableCharges"
            value={formData.maximumAcceptableCharges || ""}
            onChange={handleChange}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view" }}
            aria-label="Maximum Acceptable Charges"
          />
        </FormControl>
      </div>
      <div className="col-md-12">
        <FormControl fullWidth disabled={formMode === "view"}>
          <Typography variant="body2">
            Additional Comments / Clarifications
          </Typography>
          <TextField
            name="additionalComments"
            value={formData.additionalComments || ""}
            onChange={handleChange}
            multiline
            rows={3}
            size="small"
            sx={{ backgroundColor: "white" }}
            inputProps={{ readOnly: formMode === "view" }}
            aria-label="Additional Comments"
          />
        </FormControl>
      </div>
    </div>
  </div>
);

// TabForm Component
const TabForm = ({
  activeTab,
  setActiveTab,
  formData,
  fileUrl,
  errors,
  handleChange,
  isInstrumentSelected = true,
  formMode = "view",
  currentDate,
  countrymaster,
  incotermsMaster,
  paymentTermMaster,
  loadFormPorts,
  formOriginPortList,
  formDeliveryPortList,
  handleOpenProformaModal,
  handleOpenTradeModal,
  handleOpenKycModal,
}) => {
  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
  };

  return (
    <div className="tab-content-main">
      <div className="table-header">
        <div className="header-text">
          <div className="head-text">View RFQ - {formData.RfqId || "N/A"}</div>
        </div>
        <div className="select-filter-box">
          <FormControl fullWidth disabled={true}>
            <Box display="flex" alignItems="center" gap={2}>
              <Typography
                sx={{
                  width: "100%",
                  color: "#de6b14",
                  fontSize: "14px",
                }}
                variant="body2"
              >
                Instrument: {formData.instrument || "N/A"}
              </Typography>
            </Box>
          </FormControl>
        </div>
      </div>
      {isInstrumentSelected && (
        <>
          <div className="tabs" role="tablist">
            {[
              "RFQ Overview",
              "Trade & Transaction Details",
              "Instrument Terms",
              "Document Requirements",
              "Attachments",
              "Terms & Timing",
            ].map((tab, index) => (
              <button
                key={index}
                role="tab"
                aria-selected={activeTab === index + 1}
                className={activeTab === index + 1 ? "active" : ""}
                onClick={() => handleTabClick(index + 1)}
              >
                {tab}
              </button>
            ))}
          </div>
          <div className="tab-content">
            <form>
              {activeTab === 1 && (
                <RFQOverview
                  formData={formData}
                  errors={errors}
                  handleChange={handleChange}
                  formMode={formMode}
                  currentDate={currentDate}
                  countrymaster={countrymaster}
                  incotermsMaster={incotermsMaster}
                  paymentTermMaster={paymentTermMaster}
                  loadFormPorts={loadFormPorts}
                />
              )}
              {activeTab === 2 && (
                <TradeTransactionDetails
                  formData={formData}
                  errors={errors}
                  handleChange={handleChange}
                  formMode={formMode}
                  currentDate={currentDate}
                  formOriginPortList={formOriginPortList}
                  formDeliveryPortList={formDeliveryPortList}
                  incotermsMaster={incotermsMaster}
                />
              )}
              {activeTab === 3 && (
                <InstrumentTerms
                  formData={formData}
                  errors={errors}
                  handleChange={handleChange}
                  formMode={formMode}
                />
              )}
              {activeTab === 4 && (
                <DocumentRequirements
                  formData={formData}
                  errors={errors}
                  handleChange={handleChange}
                  formMode={formMode}
                />
              )}
              {activeTab === 5 && (
                <Attachments
                  formData={formData}
                  formMode={formMode}
                  fileUrl={fileUrl}
                  handleOpenProformaModal={handleOpenProformaModal}
                  handleOpenTradeModal={handleOpenTradeModal}
                  handleOpenKycModal={handleOpenKycModal}
                />
              )}
              {activeTab === 6 && (
                <TermsTiming
                  formData={formData}
                  errors={errors}
                  handleChange={handleChange}
                  formMode={formMode}
                  currentDate={currentDate}
                />
              )}
            </form>
          </div>
        </>
      )}
    </div>
  );
};

// Updated RFQViewer Component
const RFQViewer = ({ rfqData, onClose }) => {
  const { setLoading } = useLoading();
  const [formData, setFormData] = useState({
    requiredDocuments: {
      commercialInvoice: false,
      billOfLading: false,
      certificateOfAnalysis: false,
      packingList: false,
      certificateOfOrigin: false,
      insurancePolicy: false,
      inspectionCertificate: false,
    },
  }); // Initialize with default requiredDocuments
  const [countrymaster, setCountryMaster] = useState([]);
  const [incotermsMaster, setIncotermsMaster] = useState([]);
  const [paymentTermMaster, setPaymentTermMaster] = useState([]);
  const [formOriginPortList, setFormOriginPortList] = useState([]);
  const [formDeliveryPortList, setFormDeliveryPortList] = useState([]);
  const [activeTab, setActiveTab] = useState(1);
  const [activeUser, setActiveUser] = useState("");
  const [isLoading, setIsLoading] = useState(true); // Local loading state
  const currentDate = dayjs().format("YYYY-MM-DD");
  const bucket = process.env.REACT_APP_AMTPL_BUCKET;
  const filePath = `public/media/amtpl/`;
  const fileUrl = `https://${bucket}.s3.${config.aws_project_region}.amazonaws.com/${filePath}`;

  // Dummy handlers for modals (no-op in view mode)
  const handleOpenProformaModal = () => {};
  const handleOpenTradeModal = () => {};
  const handleOpenKycModal = () => {};

  const parseDocumentsString = (str) => {
    const defaultDocs = {
      commercialInvoice: false,
      billOfLading: false,
      certificateOfAnalysis: false,
      packingList: false,
      certificateOfOrigin: false,
      insurancePolicy: false,
      inspectionCertificate: false,
    };
    if (!str) return defaultDocs;
    const labelMap = {
      "Commercial Invoice": "commercialInvoice",
      "Bill of Lading": "billOfLading",
      "Certificate of Analysis": "certificateOfAnalysis",
      "Packing List": "packingList",
      "Certificate of Origin": "certificateOfOrigin",
      "Insurance Policy": "insurancePolicy",
      "Inspection Certificate": "inspectionCertificate",
    };
    const items = str.split(", ").filter(Boolean);
    return Object.keys(labelMap).reduce(
      (acc, label) => {
        const key = labelMap[label];
        acc[key] = items.includes(label);
        return acc;
      },
      { ...defaultDocs }
    );
  };

  // Parse rfqData into formData
  useEffect(() => {
    if (rfqData) {
      setFormData({
        Id: rfqData["Id"] || "",
        RfqId: rfqData["RfqId"] || "",
        instrument: rfqData["Instrument"] || "",
        applicantName: rfqData["ApplicantName"] || "",
        beneficiaryName: rfqData["BeneficiaryName"] || "",
        lcAmount: rfqData["LcAmount"] || "",
        lcCurrency: rfqData["Currency"] || "USD",
        lcType: rfqData["TypeOfLc"] || "",
        lcTenor: rfqData["TenorLc"] || "",
        incoterm: rfqData["Incoterms"] || "",
        countryOrigin: rfqData["OriginCountry"] || "",
        countryDestination: rfqData["DestinationCountry"] || "",
        goodsDescription: rfqData["GoodsDescription"] || "",
        requiredDocuments: parseDocumentsString(rfqData["RequiredDocuments"]),
        advisingConfirmingBank: rfqData["ConfirmingBank"] || "",
        lcOpeningBankDetails: rfqData["LcBankDetails"] || "",
        expiryDate: rfqData["ExpiryDate"] || currentDate,
        expiryPlace: rfqData["ExpiryPlace"] || "",
        paymentTerms: rfqData["PaymentTerms"] || "",
        tradeType: rfqData["TradeType"] || "",
        commodityDescription: rfqData["ComodityDescription"] || "",
        hsCode: rfqData["Hscode"] || "",
        buyerNameCountry: rfqData["BuyerName"] || "",
        sellerNameCountry: rfqData["SellerName"] || "",
        portLoading: rfqData["LoadingPort"] || "",
        portDischarge: rfqData["DischargePort"] || "",
        tradeIncoterms: rfqData["TradeIncoterms"] || "",
        shipmentDate: rfqData["ShipmentDate"] || currentDate,
        tradeValue: rfqData["TradeValue"] || "",
        advisingConfirmingBankRequired:
          rfqData["ConfirmingBankRequired"] === "Y",
        confirmationRequired: rfqData["ConfirmationRequired"] === "Y",
        partialShipmentAllowed: rfqData["PartialShipmentAllowed"] === "Y",
        transshipmentAllowed: rfqData["TransshipmentAllowed"] === "Y",
        instrumentTerms: rfqData["InstrumentTerms"] || "",
        confirmationCharges: rfqData["ConfirmationCharges"] || "",
        issuanceCharges: rfqData["IssuanceCharges"] || "",
        interestRateMargin: rfqData["InterestRateMargin"] || "",
        tenorOffered: rfqData["TenorOffered"] || "",
        additionalDocuments: rfqData["AdditionalDocuments"] || "",
        specialConditions: rfqData["SpecialClause"] || "",
        responseDeadline: rfqData["ResponseDeadlineBank"] || currentDate,
        preferredFinancingRateType: rfqData["PreferedFinanceRateType"] || "",
        maximumAcceptableCharges: rfqData["MaxAcceptableCharges"] || "",
        additionalComments: rfqData["AdditionalComments"] || "",
        proformaInvoiceFile: rfqData["ProformaInvoiceFile"]
          ? {
              name: rfqData["ProformaInvoiceFile"].split("/").pop(),
              filePath: rfqData["ProformaInvoiceFile"],
            }
          : null,
        tradeDocsFile: rfqData["TradeDocumentFile"]
          ? {
              name: rfqData["TradeDocumentFile"].split("/").pop(),
              filePath: rfqData["TradeDocumentFile"],
            }
          : null,
        kycDocsFile: rfqData["KycDocumentFile"]
          ? {
              name: rfqData["KycDocumentFile"].split("/").pop(),
              filePath: rfqData["KycDocumentFile"],
            }
          : null,
      });
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [rfqData]);

  // Load masters
  const loadCountries = useCallback(async () => {
    setLoading(true);
    try {
      const [allCountries] = await Promise.all([
        fetchData({
          target: "listDropDownOptions",
          userOrder: "Value",
          rowStart: 0,
          pageSize: 1000,
          filterTerms: { Type: "Country" },
        }),
      ]);
      setCountryMaster(allCountries.items || []);
    } catch (error) {
      console.error("Error loading countries: ", error);
      setCountryMaster([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const loadPaymentTerms = useCallback(async () => {
    setLoading(true);
    try {
      const [allPaymentTerms] = await Promise.all([
        fetchData({
          target: "listDropDownOptions",
          userOrder: "Value",
          rowStart: 0,
          pageSize: 1000,
          filterTerms: { Type: "paymentTerms" },
        }),
      ]);
      setPaymentTermMaster(allPaymentTerms.items || []);
    } catch (error) {
      console.error("Error loading paymentTerms: ", error);
      setPaymentTermMaster([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const loadIncoterms = useCallback(async () => {
    setLoading(true);
    try {
      const [allIncoterms] = await Promise.all([
        fetchData({
          target: "listDropDownOptions",
          userOrder: "Value",
          rowStart: 0,
          pageSize: 1000,
          filterTerms: { Type: "Incoterms" },
        }),
      ]);
      setIncotermsMaster(allIncoterms.items || []);
    } catch (error) {
      console.error("Error loading Incoterms: ", error);
      setIncotermsMaster([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const loadFormPorts = useCallback(
    async (country, fieldValue) => {
      setLoading(true);
      try {
        const [allPorts] = await Promise.all([
          fetchData({
            target: "listDropDownOptions",
            userOrder: "Value",
            rowStart: 0,
            pageSize: 500,
            filterTerms: { Type: "port", Subtype: country },
          }),
        ]);
        if (allPorts.items && allPorts.items.length > 0) {
          if (fieldValue === "origin") {
            setFormOriginPortList(allPorts.items);
          }
          if (fieldValue === "delivery") {
            setFormDeliveryPortList(allPorts.items);
          }
        } else {
          if (fieldValue === "origin") {
            setFormOriginPortList([]);
          }
          if (fieldValue === "delivery") {
            setFormDeliveryPortList([]);
          }
        }
      } catch (error) {
        console.error("Error loading ports: ", error);
        if (fieldValue === "origin") {
          setFormOriginPortList([]);
        }
        if (fieldValue === "delivery") {
          setFormDeliveryPortList([]);
        }
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  // Load user and masters
  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const decodedToken = jwtDecode(user.signInUserSession.idToken.jwtToken);
        setActiveUser(user.attributes.email);
      } catch (error) {
        console.error("Error checking user:", error);
      }
    };
    checkUser();
    loadCountries();
    loadPaymentTerms();
    loadIncoterms();
  }, [loadCountries, loadPaymentTerms, loadIncoterms]);

  // Load ports on country change
  useEffect(() => {
    if (formData.countryOrigin) {
      loadFormPorts(formData.countryOrigin, "origin");
    }
  }, [formData.countryOrigin, loadFormPorts]);

  useEffect(() => {
    if (formData.countryDestination) {
      loadFormPorts(formData.countryDestination, "delivery");
    }
  }, [formData.countryDestination, loadFormPorts]);

  // Dummy handleChange for view mode
  const handleChange = () => {
    // No action in view mode
  };

  if (isLoading || !rfqData) {
    return <Typography>Loading RFQ details...</Typography>;
  }

  return (
    <div className="rfq-viewer-container">
      {onClose && (
        <Button onClick={onClose} startIcon={<ArrowBackIcon />} sx={{ mb: 2 }}>
          Back to List
        </Button>
      )}
      <TabForm
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        fileUrl={fileUrl}
        formData={formData}
        errors={{}}
        handleChange={handleChange}
        formMode="view"
        currentDate={currentDate}
        countrymaster={countrymaster}
        incotermsMaster={incotermsMaster}
        paymentTermMaster={paymentTermMaster}
        loadFormPorts={loadFormPorts}
        formOriginPortList={formOriginPortList}
        formDeliveryPortList={formDeliveryPortList}
        handleOpenProformaModal={handleOpenProformaModal}
        handleOpenTradeModal={handleOpenTradeModal}
        handleOpenKycModal={handleOpenKycModal}
      />
    </div>
  );
};

export default RFQViewer;
